module.exports = __webpack_public_path__ + "static/content-above-description-6ee6b32e956fe2b21e61c54b5618ba2c.png";